import { FileDescriptor } from '@dreryk/command-query-ws-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, FileUpload, FileUploadTriggerVariant } from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../../translations';

import { StyledLogoFileUpload } from './LogoFileUpload.styled';

const MAX_HEALTHCARE_INSTITUTION_LOGO_SIZE_IN_BYTES = 5242880;
const ACCEPTED_HEALTHCARE_INSTITUTION_LOGO_EXTENSIONS = ['.svg', '.png', '.jpg', '.jpeg'];

type LogoFileUploadProps = FieldControllerProps<'logo', FileDescriptor | null> & ClassNameProp;

export const LogoFileUpload = (props: LogoFileUploadProps): JSX.Element => {
   return (
      <StyledLogoFileUpload className={props.className}>
         <FileUpload
            testId={'logo'}
            controller={props.register(props.name)}
            triggerVariant={FileUploadTriggerVariant.BUTTON}
            acceptedExtensions={ACCEPTED_HEALTHCARE_INSTITUTION_LOGO_EXTENSIONS}
            label={healthcareProviderTranslationKeys.logo}
            maxFileSizeInBytes={MAX_HEALTHCARE_INSTITUTION_LOGO_SIZE_IN_BYTES}
            placeholder={healthcareProviderTranslationKeys.chooseLogoFile}
         >
            <>
               <FileUpload.Dropzone testId={'logo'} hideIfFilled />
               <FileUpload.ImagePreviewFrame />
            </>
         </FileUpload>
      </StyledLogoFileUpload>
   );
};
